<template>
  <div class="combination">
    <div class="items">
      <div class="item" v-for="(item, i) in combination" :key="i">
        <span :style="{visibility: i !== 0 ? 'visible' : 'hidden'}">＋</span>
        <input type="text" v-model="combination[i]" placeholder="カード名"
               @keypress.shift.enter="addItem" @keypress.enter.exact="$emit('enter')">
               <!-- @keypress.enter.exact="addGroup" @keypress.shift.enter="addItem(group)"> -->
        <button :style="{visibility: i !== 0 ? 'visible' : 'hidden'}" @click="removeItem(i)">－</button>
      </div>
    </div>
    <button class="add-item" @click="addItem">＋</button>
  </div>
</template>

<style lang="stylus" scoped>
.combination
  display grid
  gap 5px
  grid-template-columns 1fr auto
  align-items center
  .items
    display grid
    grid-template-columns 1fr 1fr 1fr
.item
  display grid
  grid-template-columns auto 1fr auto
@media (max-width:767px)
  .combination
    .items
      grid-template-columns 1fr
</style>

<script>
export default {
  name: 'Combination',
  props: {
    value: {
      type: Array,
      default() { return [''] }
    }
  },
  computed: {
    combination: {
      get() { return this.value },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    removeItem(i) {
      this.combination.splice(i, 1)
    },
    addItem() {
      this.combination.push('')
      this.$nextTick(() => {
        let inputs = this.$el.querySelectorAll('input[type="text"]')
        if (inputs.length > 0) inputs[inputs.length - 1].focus()
      })
    },
  },
}
</script>
